import { Theme } from '@mui/material';
import styled from '@emotion/styled';

import { Link } from "react-router-dom";

import { Tab, Box, Accordion } from '@mui/material';

type ParamsStyle = {
    theme?: Theme;
}

export const LinkButton = styled(Link)(
    ({ theme }: ParamsStyle) => `
        width: 100%;
        display: flex;
        height: 2.5rem;
        border-radius: 5px;
        text-aling: center;
        align-items: center;
        justify-content: center;
        border: 2px solid ${theme?.palette.primary.main};

        font-size: 1rem;
        font-weight: 700;
        color: ${theme?.palette.primary.main};
`);

export const BoxBanner = styled(Box)(
    ({ theme }: ParamsStyle) => `
    width: 100%;
    max-width: 100%;
    display: none;
    flex-direction: column;
    align-items: flex-start;
    padding-bottom: 1.5rem;

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        width: auto;
        display: flex;
        max-width: 14.5rem;
        padding-bottom: 0;
    }
`);

export const BoxCustom = styled(Box)(
    ({ theme }: ParamsStyle) => `
    .MuiTabs-indicator {
        height: 5.75px;
        border-radius: 12px;
        background-color: ${theme?.palette.secondary.main};
    }

    .MuiTabs-flexContainer {
        overflow: auto;
        max-width: 310px;
        gap: .5rem;
        padding: 1.75rem 0 1rem;
        justify-content: space-between;
    }

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        .MuiTabs-flexContainer {
            gap: 0rem;
            max-width: 100%;
            padding: 1.75rem 0 1rem;
        }
    }
`);

export const TabCustom = styled(Tab)(
    ({ theme }: ParamsStyle) => `
        border-radius: 12px;
        width: 9rem;
        font-weight: 600;
        height: 5.9375rem;
        font-size: .75rem;
        text-transform: none;
        border: 2px solid rgba(12, 28, 51, 0.5);

        .MuiTab-iconWrapper {
            max-height: 2.25rem;
        }

        &.Mui-selected {
            color: white;
            background: ${theme?.palette.primary.main};

            svg {
                path {
                    fill: white;
                }
            }
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            width: 32%;
            font-size: .875rem;
        }
`);

export const AccordionCustom = styled(Accordion)(
    ({ theme }: ParamsStyle) => `
        width: 100%;
        border: none;
        box-shadow: none;
        border-radius: 0px !important;
        border-bottom: 1px solid #B2B2B2;

        ::before {
            display: none;
        }

        &.Mui-expanded {
            margin: 0;
        }
        
        #panel1d-header {
            min-height: 0;
            height: auto;
            padding: 0 1.25rem 0 0;

            &.Mui-expanded {
                min-height: 0;
            }

            .MuiAccordionSummary-content {
                margin: 0;
                &.Mui-expanded {
                    margin: 0;
                }
            } 
        }

        .MuiAccordionSummary-expandIconWrapper {
            svg {
                width: auto;
                height: 45px;
            }
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            width: 100%;
        }
`);

export const BoxSvg = styled('div')(
    ({ theme }: ParamsStyle) => `
        position: relative;
        right: 0;

        svg {
            margin-left: 1rem;
            transition: all 0.4s ease;
        }

        &.show {
            svg {
                transform: rotate(180deg);
            }
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            
        }
`);

export const LinkExtermal = styled('a')(
    ({ theme }: ParamsStyle) => `
    font-size: .9375rem;
    position: relative;
    font-weight: 700;
    color: ${theme?.palette.primary.main};
    display: flex;
    height: 40px;
    width: 14rem;
    border-radius: 5px;
    align-items: center;
    padding-left: .75rem;
    justify-content: start;
    border: 2px solid ${theme?.palette.primary.main};
    margin-bottom: .9375rem;
    
    svg {
        position: absolute;
        right: 1.25rem;
        height: 1.2rem;
    }

    &.chat {
        padding-left: 3.5rem;
        svg {
            left: 1.25rem;
        }
    }

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        width: 13rem;
    }
`);

export const BannerContent = styled.div(`
    width: 100%;
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    margin-top: .8rem;

    img {
        width: 100%;
        height: auto;
        max-width: 100%;
        border-radius: 20px;
        background-size: cover;
    }

    button {
        width: 117px;
        height: 30px;
        font-size: .75rem;
        padding: 0;
        position: absolute;
    }

    a {
        position: absolute;
        width: 120px;
        height: 40px;
        cursor: pointer;

        &.apple {
            bottom: 84px;
        }

        &.android {
            bottom: 28px;
        }
    }
`);